import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type PopUpState = {
  showPasDuePopUp: boolean;
  showPausedPopUp: boolean;
  showCanceledPopUp: boolean;
  showSevenDaysLeftPopUp: boolean;
};
export const getLocalStorageItem = (key: StripeModalKeys) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : false;
};
const setPopUpState = (state: any, action: PayloadAction<boolean>, key: string) => {
  state[key] = action.payload;
  localStorage.setItem(key, JSON.stringify(action.payload));
};

export enum StripeModalKeys {
  PasDue = 'showPasDuePopUp',
  Paused = 'showPausedPopUp',
  Canceled = 'showCanceledPopUp',
  SevenDaysLeft = 'showSevenDaysLeftPopUp',
}

const stripeSubscriptionPopUpSlice = createSlice({
  name: 'stripePopUps',
  initialState: <PopUpState>{
    showPasDuePopUp: getLocalStorageItem(StripeModalKeys.PasDue),
    showPausedPopUp: getLocalStorageItem(StripeModalKeys.Paused),
    showCanceledPopUp: false,
    showSevenDaysLeftPopUp: getLocalStorageItem(StripeModalKeys.SevenDaysLeft),
  },
  reducers: {
    setPasDuePopUp: (state, action: PayloadAction<boolean>) => {
      setPopUpState(state, action, StripeModalKeys.PasDue);
    },
    setPausedPopUp: (state, action: PayloadAction<boolean>) => {
      setPopUpState(state, action, StripeModalKeys.Paused);
    },
    setSevenDaysLeftPopUp: (state, action: PayloadAction<boolean>) => {
      setPopUpState(state, action, StripeModalKeys.SevenDaysLeft);
    },
  },
});

export const { setPasDuePopUp, setPausedPopUp, setSevenDaysLeftPopUp } =
  stripeSubscriptionPopUpSlice.actions;
export default stripeSubscriptionPopUpSlice.reducer;
